<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>This book is the sequel to my thriller ‘Coltan, Congo’s Curse’ and dedicated to my fellow people, everyone ever lived, alive now and future generations, to nature and the universe. It addresses our contemporary societal crises, but it attempts to offer plausible, logical- and scientific solutions to protect human and non-human life and wellbeing, social cohesion and the environment. You may understand Hydro Solar Plasma as a symbol of the unlimited creativity of mankind as long as people use all relevant information, which are called ‘reality’ and ‘truth’. Very simple and easy indeed.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?e6a67bd6